import React, { useEffect, useState } from 'react';
import { Target, Cpu, Banknote, KeyRound, Beer } from 'lucide-react';
import appDataService, { Pub } from '../services/appDataService';
import ListingExplorer, {
  ListingFilterDef,
  ListingBadge,
  ListingItem,
} from '../components/listings/ListingExplorer';

const FILTERS: ListingFilterDef[] = [
  { key: 'steeldart', label: 'Steeldart', icon: Target, test: (i) => (i as Pub).steeldart === true },
  { key: 'edart', label: 'E-Dart', icon: Cpu, test: (i) => (i as Pub).edart === true },
  { key: 'flat', label: 'Flatrate', icon: Banknote, test: (i) => (i as Pub).flat === true },
  { key: 'rentable', label: 'Mietbar', icon: KeyRound, test: (i) => (i as Pub).rentable === true },
];

const badgesFor = (item: ListingItem): ListingBadge[] => {
  const pub = item as Pub;
  const badges: ListingBadge[] = [];
  if (pub.steeldart) badges.push({ key: 'steel', label: 'Steeldart', icon: Target });
  if (pub.edart) badges.push({ key: 'edart', label: 'E-Dart', icon: Cpu });
  if (pub.flat) badges.push({ key: 'flat', label: 'Flatrate', icon: Banknote });
  if (pub.rentable) badges.push({ key: 'rent', label: 'Mietbar', icon: KeyRound });
  return badges;
};

const PubsPage: React.FC = () => {
  const [pubs, setPubs] = useState<Pub[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    appDataService
      .getPubs()
      .then((data) => {
        if (!cancelled) setPubs(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setPubs([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ListingExplorer
      items={pubs}
      loading={loading}
      title="Dart-Spielstätten"
      subtitle="Wo wirfst du heute? Kneipen, Bars & Pubs mit Dartboards in deiner Nähe entdecken."
      searchPlaceholder="Spielstätte oder Ort suchen..."
      countLabel="Spielstätten"
      countLabelSingular="Spielstätte"
      emptyIcon={Beer}
      fallbackIcon={Beer}
      emptyLabel="Keine Spielstätten gefunden"
      routeBase="/spielstaette"
      filters={FILTERS}
      badges={badgesFor}
      seoTitle="Dart-Spielstätten - Kneipen & Bars | DartCloud"
      seoDescription="Finde Dart-Spielstätten, Kneipen und Bars mit Dartboards in deiner Nähe auf DartCloud."
    />
  );
};

export default PubsPage;
